import $ from 'jquery'

$(document).on(
  'click',
  'button[data-behaviour="cancel-edit-reconciliation-text-name"]',
  function () {
    $('span[data-behaviour~="reconciliation-text-name"]').show()
    $('span[data-behaviour~="edit-reconciliation-text-name-form"]').empty()
  }
)

$(document).on(
  'click',
  'button[data-behaviour="cancel-edit-permanent-text-title"]',
  function () {
    $('[data-behaviour~="permanent-text-title"]').show()
    $('[data-behaviour~="edit-permanent-text-title-form"]').empty()
    $('[data-behaviour~="edit-permanent-text-title-form"]').text(
      $(this).data('original-title')
    )
  }
)
